"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductSelection;
(function (ProductSelection) {
    ProductSelection["CHARGING_STATION"] = "particulier-laden";
    ProductSelection["CHARGE_CARD"] = "particulier-laadpas";
    ProductSelection["CHARGING_STATION_REIMBURSEMENT"] = "reimbursement-laden";
})(ProductSelection || (ProductSelection = {}));
exports.default = ProductSelection;
